import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { notificationInterface } from 'src/app/util/interfaces/notification';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class NotificationManagementService {
	private registerNotificationsUrl = environment.baseApiUrl + 'register/notification';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getNotifications(summary: string, type: string): Observable<notificationInterface[]> {
		return this.http
			.get<any[]>(this.registerNotificationsUrl, {
				headers: this.headers,
				params: {
					summary: summary,
					type: type,
				},
			})
			.pipe(
				map((notificationArrRes) => {
					const newNotificationArray: notificationInterface[] = [];
					for (const notification of notificationArrRes) {
						const newNotification: notificationInterface = {
							id: notification.id,
							customer: notification.customer,
							type: notification.type,
							summary: notification.summary,
							description: notification.description,
							limit_date: notification.limit_date,
						};
						newNotificationArray.push(newNotification);
					}

					return newNotificationArray;
				})
			);
	}

	createNotification(newNotification: notificationInterface): Observable<string[]> {
		return this.http.post<any>(this.registerNotificationsUrl, newNotification, { headers: this.headers, params: {} }).pipe(
			map((res) => {
				return res.data;
			})
		);
	}

	updateNotification(updatedNotification: notificationInterface): Observable<string[]> {
		return this.http.put<any>(this.registerNotificationsUrl, updatedNotification, { headers: this.headers, params: {} });
	}

	deleteNotification(id: string): Observable<any> {
		return this.http.delete(this.registerNotificationsUrl, { headers: this.headers, params: { id: id } });
	}
}
